var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"bar"},_vm._l((_vm.topBarList),function(item){return _c('v-tooltip',{key:item.value,attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({class:[
            'icon', 
            item.icon, 
            item.value === 'cut' ? (_vm.isCut && 'active') : void 0,
            item.value === 'rect' ? (_vm.isRect && 'active') : void 0,
            item.value === 'text' ? (_vm.isText && 'active') : void 0,
            item.value === 'link' && 'link'
          ],on:{"click":function($event){return _vm.handleEvent(item.value)}}},'span',attrs,false),on))]}}],null,true)},[_c('span',[_vm._v(_vm._s(item.text))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }